export default __webpack_public_path__ + "static/imgWeddingpng-055564befadd91a81ee74d5a23c7593c.png";